import { render, staticRenderFns } from "./ThresholdConfiguration.vue?vue&type=template&id=2831fa10&"
import script from "./ThresholdConfiguration.vue?vue&type=script&lang=js&"
export * from "./ThresholdConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./ThresholdConfiguration.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports